import React, { Component } from 'react';
import style from './index.module.css';

class Chapter5 extends Component<any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      status,
      chargeTotal,
      carbonDioxide,
      isMultiCar,
      rule
    } = this.props.data;
    // if (status === 0) return;
    const { setInstructionModel } = this.props;

    return (
      <div
        className={style.pageBgType4}
        style={{
          height: document.documentElement.clientHeight,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          paddingRight: 0,
          paddingLeft: 0,
          paddingTop: 0
        }}
      >
        <div className={style.chapter5Icon} />
        {status === 1 && (
          <div className={style.itemBox}>
            {isMultiCar && rule && (
              <div
                className={style.instructionsIconBox}
                onClick={() => setInstructionModel(rule)}
              />
            )}
            {/* <div className={style.xpIconBox} /> */}
            <p className={style.ordinaryText}>
              <span className={style.blueBigText}>{chargeTotal}度</span>
              你在2021年充电的度数
              <br />
              相当于减排了
              <span className={style.blueNormalText}>
                {carbonDioxide}千克二氧化碳
              </span>
              <br />
              <br />
            </p>
            <p className={style.grayNormalText}>
              愿你每天起床，都能呼吸到新鲜空气
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default Chapter5;
